
















import Component from 'vue-class-component'
import Vue from 'vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'

@Component({
  name: 'resource-toolbar',
  components: { RespondecoToolbar },
})
export default class ResourceToolbar extends Vue {}
